import script from "./AdminListTable.vue?vue&type=script&setup=true&lang=ts&generic=Row%20extends%20AdminListTableRow"
export * from "./AdminListTable.vue?vue&type=script&setup=true&lang=ts&generic=Row%20extends%20AdminListTableRow"

import "./AdminListTable.vue?vue&type=style&index=0&id=64233a2c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64233a2c"]])

export default __exports__